import React from "react";
import "./CPInput.css";
import "./CPTextarea.css";

/**
 * Shared CrewPilot textarea — canonical ordinary multiline field.
 *
 * Public API:
 * - props: className, label, value, onChange(value), placeholder, required,
 *   disabled, readOnly, rows, textareaRef, id, name, maxLength,
 *   voiceFieldId, voiceActive, onBlur, onFocus, onKeyDown,
 *   aria-label / aria-* via rest
 * - Shares .cp-input-group / .cp-input-label with CPInput
 */
export function CPTextarea({
  className = "",
  label,
  value,
  onChange,
  placeholder = "",
  required = false,
  disabled = false,
  readOnly = false,
  rows,
  textareaRef,
  id,
  name,
  maxLength,
  voiceFieldId,
  voiceActive = false,
  onBlur,
  onFocus,
  onKeyDown,
  ...rest
}) {
  const groupClass = [
    "cp-input-group",
    voiceActive ? "cp-input-group--voice-active" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const textareaClass = [
    "cp-textarea",
    rows != null ? "cp-textarea--rows" : "",
    voiceActive ? "cp-textarea--voice-active" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={groupClass} data-voice-field={voiceFieldId}>
      {label && (
        <label className="cp-input-label" htmlFor={id}>
          {label}
          {required && <span className="cp-input-required">*</span>}
        </label>
      )}

      <textarea
        ref={textareaRef}
        id={id}
        name={name}
        className={textareaClass}
        value={value ?? ""}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        rows={rows}
        maxLength={maxLength}
        onChange={
          disabled || readOnly ? undefined : (e) => onChange?.(e.target.value)
        }
        onBlur={disabled || readOnly ? undefined : onBlur}
        onFocus={disabled ? undefined : onFocus}
        onKeyDown={disabled ? undefined : onKeyDown}
        {...rest}
      />
    </div>
  );
}
